import { render, staticRenderFns } from "./HeaderSmall.vue?vue&type=template&id=47a2f455&scoped=true&"
import script from "./HeaderSmall.vue?vue&type=script&lang=js&"
export * from "./HeaderSmall.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSmall.vue?vue&type=style&index=0&id=47a2f455&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a2f455",
  null
  
)

export default component.exports